import React from 'react';
import './IOSPWAInstallManual.css';

export default function IOSPWAInstallManual({ onClose }) {
  return (
    <div className="ios-install-backdrop" role="dialog" aria-modal="true">
      <div className="ios-install-card">
        <button className="ios-install-close" onClick={onClose} aria-label="Close">×</button>
        
        <div className="ios-install-header">
          <h2>Install Curio as App</h2>
          <p>Add Curio to your home screen for the best experience.</p>
        </div>

        <div className="ios-install-steps">
          <div className="ios-install-step">
            <div className="ios-step-icon">
              {/* Apple-style Share icon (square with arrow up) */}
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 12v6a2 2 0 002 2h12a2 2 0 002-2v-6" />
                <polyline points="16 6 12 2 8 6" />
                <line x1="12" y1="2" x2="12" y2="15" />
              </svg>
            </div>
            <div className="ios-step-text">
              <strong>1) Tap the Share button</strong>
            </div>
          </div>

          <div className="ios-install-step">
            <div className="ios-step-icon">
              {/* Plus square icon - white */}
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="12" y1="8" x2="12" y2="16"></line>
                <line x1="8" y1="12" x2="16" y2="12"></line>
              </svg>
            </div>
            <div className="ios-step-text">
              <strong>2) Add to Home Screen</strong>
              <span>Scroll down and press "Add to Home Screen"</span>
            </div>
          </div>
        </div>

        <div className="ios-install-why">
          <strong>Why install this way?</strong>
          <p>By installing via this method we can avoid the 30 % Apple Tax the App Store takes.</p>
        </div>
      </div>
    </div>
  );
} 